<template>
    <div class="form">
        <h4 class="step-title">
            Have you had a DUI conviction in the past 3 years or need an SR-22 form?
        </h4>
        <div class="step-content d-flex flex-column align-items-center step-button-list wider">
            <yes-no-button-list v-bind:onclick="complete" v-bind:value="lead.autoInsurance.dui"/>
        </div>
    </div>
</template>

<script>
    import YesNoButtonList from "../shared/YesNoButtonList.vue"

    export default {
        name: "DuiNeedsSr22",
        components: {
            YesNoButtonList
        },
        props: {
            lead: Object
        },
        methods: {
          complete: function(value) {
              this.lead.autoInsurance.dui = value;
              this.lead.autoInsurance.needsSr22 = value;
              this.$emit("complete", this.$options.name, value);
          }
        }
    }
</script>
